<template>
    <!-- Start Main Content -->
    <div class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">
     <div class="card p-0 lg:min-h-[calc(100vh_-_theme('spacing.header')_*_1.4)] xl:min-h-[calc(100vh_-_theme('spacing.header')_*_1.6)]">
         <div class="flex flex-col gap-2 sm:flex-center-between sm:flex-row px-4 py-5 sm:p-7 bg-gray-200/30 dark:bg-dark-card-shade">
             <div>
                 <h6 class="card-title">Services</h6>
             </div>
             <a v-show="userRole === '1'" class="btn b-solid btn-primary-solid" data-modal-target="editModal" @click="addModal()">Add Service</a>
         </div>
         <!-- Start All Language List Table -->
         <div class="p-3 sm:p-4">
             <div class="overflow-x-auto scrollbar-table">
                 <table class="table-auto w-full whitespace-nowrap text-left text-gray-500 dark:text-dark-text leading-none">
                     <thead class="border-b border-gray-200 dark:border-dark-border font-semibold">
                         <tr>
                             <th class="px-3.5 py-4">Service Name</th>
                             <th class="px-3.5 py-4">Service Days</th>
                             <th class="px-3.5 py-4">Rate</th>
                             <th class="px-3.5 py-4">Status</th>
                             <th class="px-3.5 py-4">Action</th>
                         </tr>
                     </thead>
                     <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
                         <tr class="hover:bg-primary-200/50 dark:hover:bg-dark-icon hover:text-gray-500 dark:hover:text-white" v-for="(item ,index)  in serviceList" :key="item.id" > 
                             <td class="px-3.5 py-4">{{item.name}}</td>
                             <td class="px-3.5 py-4">{{item.days}}</td>
                             <td class="px-3.5 py-4">{{item.cost}}</td>
                             <td class="px-3.5 py-4">{{item.status}}</td>
                             <td class="px-3.5 py-4">
                                 <div class="flex items-center gap-1">
                                     <button class="btn-primary"  @click="editModal(item)"  v-show="userRole === '1'">
                                         <i class="ri-edit-2-line text-inherit text-[13px]"></i>Edit
                                     </button>
                                     <button class="btn-primary"  @click="addservice_subscriptionModal(item)"  >
                                        <i class="ri-add-line text-inherit text-[13px]"></i>Subscription
                                    </button>
                                     <button class="btn-danger" @click="deleteModal(item.id)" v-show="userRole === '1'">
                                         <i class="ri-delete-bin-line text-danger text-[13px]"></i>Delete
                                     </button>
                                 </div>
                             </td>
                         </tr>
                         
                     </tbody>
                 </table>
             </div>
         </div>
         <!-- End All Language List Table -->
     </div>
 </div>
 <!-- End Main Content -->

 <!-- Start Edit Modal -->
 <div id="editModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full" style="    background: #00000052;">
     <div class="p-4 w-full max-w-lg max-h-full">
         <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square">
             <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                 <i class="ri-close-line text-inherit text-xl leading-none"></i>
             </button>
             <div class="p-4 md:p-5">
                
                     <div class="mt-7">
                         <label for="tagname" class="form-label">Service Name *</label>
                         <input type="text" v-model="services.name" class="form-input" id="first_input" placeholder="Service Name" autocomplete="off" required >
                     </div>

                     <div class="mt-7">
                        <label for="tagname" class="form-label">Service Cost *</label>
                        <input type="number" v-model="services.cost" class="form-input" id="first_input" placeholder="Service Cost" autocomplete="off" required >
                    </div>

                    <div class="mt-7">
                        <label for="tagname" class="form-label">Service Description *</label>
                        <input type="text" v-model="services.description" class="form-input" id="first_input" placeholder="Service Description" autocomplete="off" required >
                    </div>

                    <div class="mt-7">
                        <label for="tagname" class="form-label">Service Days *</label>
                        <input type="number" v-model="services.days" class="form-input" id="first_input" placeholder="Service Days" autocomplete="off" required >
                    </div>



                     <div class="mt-7">
                         <label for="tagname" class="form-label">Service Status *</label>
                         <select   v-model="services.status" class="form-input">
                             <option value="Active">Active</option>
                             <option value="Deactive">Deactive</option>
                         </select>

                     </div>
                     <div class="flex justify-end mt-7">
                         <button @click="save_service" class="btn b-solid btn-primary-solid cursor-pointer shadow-sm">Save</button>
                     </div> 
             </div>
         </div>
     </div>
 </div>
 <!-- End Edit Modal -->
  <!-- Start service subscription Modal -->
 <div id="addservice_subscriptionModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full" style="    background: #00000052;">
    <div class="p-4 w-full max-w-lg max-h-full scroll">
        <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square">
            <button type="button" @click="closeservicesubscriptionModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                <i class="ri-close-line text-inherit text-xl leading-none"></i>
            </button>
            <div class="p-4 md:p-5">
                <input type="hidden" v-model="services_subscription.service_id" class="form-input" id="first_input"  autocomplete="off" required >
                <div class="mt-7">
                    <label for="tagname" class="form-label">{{services.name}}</label>
                </div>
                <div class="mt-7">
                    <label for="tagname" class="form-label">Choose Member Name *</label>
                    <select ref="memberSelect" v-model="services_subscription.member_id" class="form-input">
                        <option v-for="customer in memberList" :value="customer.id">{{ customer.member_info }}</option>
                    </select>
                </div>                
                <div v-if="lastSubscriptionDates.from_date && lastSubscriptionDates.to_date" class="mt-2">
                    <span style="color: red;">Last Subscription {{ lastSubscriptionDates.from_date }} to {{ lastSubscriptionDates.to_date }}</span>
                  </div>

                    <div class="mt-7">
                       <label for="tagname" class="form-label">From Date *</label>
                       <input type="date" v-model="services_subscription.from_date" class="form-input" id="first_input" placeholder="From Date" autocomplete="off" required @input="setNextMonthToDate">
                   </div>

                   <div class="mt-7">
                       <label for="tagname" class="form-label">To Date *</label>
                       <input type="date" v-model="services_subscription.to_date" class="form-input" id="first_input" placeholder="To Date" autocomplete="off" required >
                   </div>

                   <div class="mt-7">
                       <label for="tagname" class="form-label">Amount *</label>
                       <input type="number" v-model="services_subscription.total_amt" class="form-input" id="first_input" placeholder="Amount" autocomplete="off" required >
                   </div>
                   <div class="mt-7">
                    <label for="tagname" class="form-label">Paid *</label>
                    <input type="number" v-model="services_subscription.paid" class="form-input" id="first_input" placeholder="Paid" autocomplete="off" required >
                </div>
                   <div class="mt-7">
                    <label for="tagname" class="form-label">Note *</label>
                    <input type="text" v-model="services_subscription.note" class="form-input" id="first_input" placeholder="Note" autocomplete="off" required >
                </div>
                <div class="mt-7">
                    <label for="tagname" class="form-label">Choose Staff Name *</label>
                    <select ref="staffSelect" v-model="services_subscription.staff_id" class="form-input">
                        <option v-for="staff in staffList" :value="staff.id">{{ staff.firstname }}</option>
                    </select>
                </div>     
                    <div class="flex justify-end mt-7">
                        <button @click="save_service_subscription" class="btn b-solid btn-primary-solid cursor-pointer shadow-sm">Save</button>
                    </div> 
            </div>
        </div>
    </div>
</div>
<!-- End service subscription Modal -->

 <!-- Start Delete Modal -->
 <div id="deleteModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full" style="    background: #00000052;">
     <div class="p-4 w-full max-w-md max-h-full">
         <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square">
             <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                 <i class="ri-close-line text-inherit text-xl leading-none"></i>
             </button>
             <div class="p-4 md:p-5 text-center">
                 <img src="assets/images/icons/delete-record.png" alt="delete" class="block h-12 mx-auto">
                 <div class="mt-5 text-center">
                     <h5 class="mb-1">Are you sure?</h5>
                     <p class="text-slate-500 dark:text-zink-200">Are you certain you want to delete this record?</p>
                     <div class="flex justify-center gap-2 mt-6">
                         <button type="reset" @click="closeModal" class="btn b-light btn-danger-light btn-sm">Cancel</button>
                         <button type="submit" @click="delete_category" class="btn b-solid btn-danger-solid btn-sm">Yes, Delete It!</button>
                     </div>
                 </div>
             </div>
         </div>
     </div>
 </div>
 <!-- End Delete Modal -->
</template>
<style scoped>
#addservice_subscriptionModal .scroll {
    max-height: 100vh; 
    overflow-y: auto; 
}
</style>
<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import axios from 'axios';

export default {
name: 'Services',
components: {
 
} ,
mounted(){
 this.getBasics();
 this.initSelect2();
 const today = new Date().toISOString().split('T')[0];
        this.services_subscription.from_date = today;
        this.services_subscription.to_date = today;
},
data() {
 return {
     isAdd:0,
     isEdit:0,
     isDelete: 0,
     deleteId:0,
     serviceList:[],
     memberList:[],
     staffList:[],
     userRole: localStorage.getItem('userRole'),
     services:{
        name:'',
        cost:'',
        description:'',
        days:'',
        status:'',

     },
     lastSubscriptionDates: {
        from_date: null,
        to_date: null,
      },
     services_subscription:{
        service_id:'',
        member_id:'',
        from_date:'',
        to_date:'',
        total_amt:'',
        paid:'',
        note:'',
        staff_id:''

     }
    //  cat:{name:'',status:'Active'},
    //  employees: {empname:'',emprole:'0',isMainAdmin:0},
 }
 },
 created() {
    // Automatically set `to_date` one month ahead if `from_date` is already set when the component loads
    if (this.services_subscription.from_date) {
      this.setNextMonthToDate();
    }
  },
methods:{
    setNextMonthToDate() {
      if (this.services_subscription.from_date) {
        const fromDate = new Date(this.services_subscription.from_date);
        fromDate.setMonth(fromDate.getMonth() + 1); // Add one month
        this.services_subscription.to_date = fromDate.toISOString().split('T')[0]; // Format as YYYY-MM-DD
      }
    },
    closeservicesubscriptionModal()
    {
        $('#addservice_subscriptionModal').addClass('hidden');
    },
 closeModal(){
    // $('#editModal').modal('hide');
         $("#editModal").addClass('hidden');
         $("#deleteModal").addClass('hidden');
     this.isAdd=0;
     this.isEdit=0;
     this.isDelete=0;
     this.deleteId=0;
 },
 addModal(){
     this.services={name:'',status:'Active'};
     if(!this.isAdd)
         $("#editModal").removeClass('hidden');
     else
         $("#editModal").addClass('hidden');
         $("#first_input").focus();
     this.isAdd=!this.isAdd;
 },

 editModal(item){
     if(item){
         let copy = JSON.parse(JSON.stringify(item));
         this.services=copy;
        // console.log(this.services);
     }
     if(!this.isEdit)
         $("#editModal").removeClass('hidden');
     else
         $("#editModal").addClass('hidden');
     this.isEdit=!this.isEdit;
 },
 initSelect2() {
            const vm = this;

            // Initialize Select2 on the select element with ref
            $(this.$refs.memberSelect).select2();

            // Sync Select2 selection with Vue's v-model
            $(this.$refs.memberSelect).on('change', function () {
                vm.services_subscription.member_id = $(this).val();
                vm.fetchLastSubscription();
            });

            $(this.$refs.staffSelect).select2();

            // Sync Select2 selection with Vue's v-model
            $(this.$refs.staffSelect).on('change', function () {
                vm.services_subscription.staff_id = $(this).val();
            });
        },
 addservice_subscriptionModal(item){
    
        let copy = JSON.parse(JSON.stringify(item));
        this.services_subscription.service_id=copy.id;
        this.services.name = copy.name;
         $("#addservice_subscriptionModal").removeClass('hidden');
         this.getBasics();
 },
 
 deleteModal(id){
     this.deleteId=id;
     if(!this.isDelete)
         $("#deleteModal").removeClass('hidden');
     else
         $("#deleteModal").addClass('hidden');
     this.isDelete=!this.isDelete;
 },
 async getBasics() {
       var self=this;
         axios.post('getallServices').then(function (response) {
                 self.serviceList=response.data.services;
                 self.employees=response.data.userDetails;
                 self.memberList=response.data.customer;
                 self.staffList=response.data.stafflist;
                });
  },
  async fetchLastSubscription() {
      try {
        const response = await axios.post('getLastSubscription', {
          member_id: this.services_subscription.member_id,
        });
        const data = response.data.lastsubscription;
        this.lastSubscriptionDates = {
          from_date: data.from_date,
          to_date: data.to_date,
        };
      } catch (error) {
        console.error('Error fetching last subscription:', error);
      }
    },
  save_service() {
             var self = this; 
             axios.post('addService', this.services)
                 .then(response => {
                     var msg = response.data.msg;
                     var isSuccess = response.data.status;
                    //  self.packageList=response.data.services;
                    //  self.employees=response.data.userDetails;
                     self.getBasics();
                     self.closeModal();
                    //  self.cat={name:'',status:'Active'};

                     //self.$swal(msg);
                    //  if (isSuccess == 1) {
                    //      self.closeModal();
                    //  }
                 })
                 .catch(error => {
                     console.log('Error on Authentication: ' + error);
                 });
         },
         save_service_subscription() {
             var self = this; 
             axios.post('addServiceSubscription', this.services_subscription)
                 .then(response => {
                     var msg = response.data.msg;
                     var isSuccess = response.data.status;

                     self.$swal(msg);
                     if (isSuccess == 1) {
                         self.closeservicesubscriptionModal();
                     }
                 })
                 .catch(error => {
                     console.log('Error on Authentication: ' + error);
                 });
         },
         delete_category() {
             var self = this; 
             axios.post('deleteService', {deleteId:this.deleteId})
                 .then(response => {
                    self.serviceList=response.data.services;
                    self.employees=response.data.userDetails;
                      self.closeModal(); 
                 })
                 .catch(error => {
                     console.log('Error on Authentication: ' + error);
                 });
         },
},
watch: {
        memberList() {
            this.$nextTick(() => {
                // Reinitialize Select2 after memberList updates
                $(this.$refs.memberSelect).select2('destroy').select2();
            });
        },
        staffList() {
            this.$nextTick(() => {
                // Reinitialize Select2 after memberList updates
                $(this.$refs.staffSelect).select2('destroy').select2();
            });
        }
    }
}
</script>
